import { createStore, combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "../reducer/index";
import { encryptTransform } from "redux-persist-transform-encrypt";
function configureStore(initialState = {}) {
    const reducer = combineReducers({
        // auth: () => ({ mock: true }),
        // localkey: persistReducer(
        //     {
        //         key: "localkey", // key for localStorage key, will be: "persist:form"
        //         storage,
        //         debug: true,
        //         // blacklist: ['foo'],
        //         tranforms: [
        //             encryptTransform({
        //                 secretKey: "ialt-key",
        //                 onError: function (error) {
        //                 },
        //             }),
        //         ]
        //     },
            rootReducer

        // ),
    });

    const store = createStore(persistReducer(
        {
            key: "root",
            debug: true,
            storage,
            // whitelist: ['auth'],
            transforms: [
                encryptTransform({
                  secretKey: 'ialt-key',
                  onError: function (error) {
                    // Handle the error.
                  },
                }),
              ],
        }, reducer
    ), initialState,
        window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    );
    const persistor = persistStore(store, null, () => {
        // if you want to get restoredState
    });

    store.subscribe(() => {
    });

    return { store, persistor };
}

export default configureStore;